import React, { useEffect, useState } from 'react';

import styles from './home-page.module.css';

import { Link, redirect, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AddGroup from '../../components/AddGroup/AddGroup';
import { getGrupListDb } from '../../firebase';
import { addGroupRedux } from '../../store/slices/groupsSlice';
import LoaderPage from '../../components/LoaderPage/LoaderPage';
import { pathHome } from '../../path';
import { TapClickSvg, ReverseSvg } from '../../SVGComponents/SVGComponents';

const renderGroupsBtn = (items) => {
  return items.map((item) => {
    return (
      <Link
        key={item.group_id}
        className={styles.btn_link}
        to={`/${pathHome}/group/${item.group_id}`}>
        {item.groupName}
      </Link>
    );
  });
};

const getGropItems = (groupsProps, value) => {
  const groups = [...groupsProps];

  let groupsResult = groups.filter((item) => {
    if (item.sortValue && item.sortValue === value) {
      return true;
    }
    return false;
  });

  return groupsResult;
};

const HomePage = () => {
  const dispatch = useDispatch();
  const [loaderPage, setLoaderPage] = useState(true);
  const groups = useSelector((state) => state.groups.groupsList);

  useEffect(() => {
    const fetchData = async () => {
      const groupsListArray = await getGrupListDb();
      // console.log('HomePage/groupsListArray ==== ', groupsListArray);
      dispatch(addGroupRedux(groupsListArray));
      setLoaderPage(false);
    };
    if (!groups || !groups.length) {
      fetchData();
    } else {
      setLoaderPage(false);
    }
  }, []);

  return (
    <>
      <div className={styles.header_wrapper}>Головна</div>
      <div className={styles.content_wrapper}>
        {groups && groups.length ? (
          <>
            {getGropItems(groups, 'grop_draft').length ? (
              <>
                <div className={'fw_600'}>Чорновик</div>

                <div className={styles.group_links_wrapper}>
                  {renderGroupsBtn(getGropItems(groups, 'grop_draft'))}
                </div>
              </>
            ) : (
              ''
            )}

            {getGropItems(groups, 'grop_grops').length ? (
              <>
                <div className={'fw_600'}></div>
                <div className={'fw_600 df jcsb pr_15 aife'}>
                  Груповий супровід
                  <TapClickSvg />
                </div>

                <div className={styles.group_links_wrapper}>
                  {renderGroupsBtn(getGropItems(groups, 'grop_grops'))}
                </div>
              </>
            ) : (
              ''
            )}
            {getGropItems(groups, 'grop_individual').length ? (
              <>
                <div className={'fw_600 df jcsb pr_15 aife'}>
                  Індивідуальний супровід
                  <TapClickSvg />
                </div>
                <div className={styles.group_links_wrapper}>
                  {renderGroupsBtn(getGropItems(groups, 'grop_individual'))}
                </div>
              </>
            ) : (
              ''
            )}
            {getGropItems(groups, 'grop_free').length ? (
              <>
                <div className={'fw_600 df jcsb pr_15 aife'}>
                  Безкоштовной супровід
                  <TapClickSvg />
                </div>
                <div className={styles.group_links_wrapper}>
                  {renderGroupsBtn(getGropItems(groups, 'grop_free'))}
                </div>
              </>
            ) : (
              ''
            )}
            {getGropItems(groups, 'grop_test').length ? (
              <>
                <div className={'fw_600 df jcsb pr_15 aife'}>
                  Для тестування
                  <TapClickSvg />
                </div>
                <div className={styles.group_links_wrapper}>
                  {renderGroupsBtn(getGropItems(groups, 'grop_test'))}
                </div>
              </>
            ) : (
              ''
            )}
          </>
        ) : loaderPage ? (
          <div className={styles.group_links_wrapper}>Загрузка...</div>
        ) : (
          <div className={styles.group_links_wrapper}>Груп не знайдено:(</div>
        )}

        <AddGroup />

        <Link className={styles.btn_link} to={`/${pathHome}/ingredients`}>
          Інгридієнти
        </Link>
        <Link className={styles.btn_link} to={`/${pathHome}/products`}>
          Продукти
        </Link>
        <Link className={styles.btn_link} to={`/${pathHome}/clients`}>
          Клієнти
        </Link>
        <Link className={styles.btn_link} to={`/${pathHome}/tips`}>
          Поради
        </Link>
        <Link className={styles.btn_link} to={`/${pathHome}/contacts`}>
          Контакти
        </Link>
        <Link className={styles.btn_link} to={`/${pathHome}/usersActivity`}>
          Активність
        </Link>
        <Link className={styles.btn_link + ' ' + styles.site_btn} to={`/${pathHome}/site`}>
          Сайт
        </Link>
      </div>
      {loaderPage && <LoaderPage />}
    </>
  );
};

export default HomePage;
